import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Reveal from './Reveal';
import portraitWebp500 from '../assets/owner-portrait-500.webp';
import portraitWebp800 from '../assets/owner-portrait-800.webp';
import portraitWebp1200 from '../assets/owner-portrait-1200.webp';
import portraitJpg800 from '../assets/owner-portrait-800.jpg';
import levelWebp900 from '../assets/work/processed/spirit-level-900.webp';
import levelWebp600 from '../assets/work/processed/spirit-level-600.webp';
import levelJpg900 from '../assets/work/processed/spirit-level-900.jpg';
import './CraftStory.css';

const CraftStory = () => (
  <section className="craft-story" id="about" aria-labelledby="craft-story-title" data-testid="craft-story">
    <div className="craft-story__inner">
      <Reveal className="craft-story__images">
        <figure className="craft-story__portrait">
          <picture>
            <source type="image/webp"
              srcSet={`${portraitWebp500} 500w, ${portraitWebp800} 800w, ${portraitWebp1200} 1200w`}
              sizes="(max-width: 767px) 85vw, (max-width: 1100px) 40vw, 490px" />
            <img src={portraitJpg800} width="1313" height="1562" loading="lazy" decoding="async"
              alt="Corey, the carpenter behind FairFix, on site inside a timber frame" />
          </picture>
          <figcaption>Corey <span>Hobart, Australia</span></figcaption>
        </figure>
        <figure className="craft-story__archive">
          <picture>
            <source type="image/webp" srcSet={`${levelWebp600} 600w, ${levelWebp900} 900w`}
              sizes="(max-width: 767px) 40vw, 235px" />
            <img src={levelJpg900} width="900" height="725" loading="lazy" decoding="async"
              alt="A younger Corey checking wall framing with a straightedge during his apprenticeship" />
          </picture>
          <figcaption>Where the craft began.</figcaption>
        </figure>
      </Reveal>

      <Reveal className="craft-story__copy" delay={80}>
        <p className="craft-story__eyebrow">The person behind the work</p>
        <h2 className="craft-story__title" id="craft-story-title">
          Good work starts with a <em>good carpenter.</em>
        </h2>
        <p className="craft-story__body">
          I&rsquo;m Corey, the carpenter behind FairFix. I&rsquo;m based in Hobart,
          Australia, with a Certificate III in Carpentry and 20 years on the tools.
        </p>
        <p className="craft-story__body">
          I work across carpentry, decks, fencing and interiors &mdash; from the
          detail that needs fixing to a space you want to make your own.
        </p>
        <dl className="craft-story__credentials">
          <div><dt>20 years</dt><dd>On the tools</dd></div>
          <div><dt>Cert III</dt><dd>In Carpentry</dd></div>
        </dl>
        <div className="craft-story__actions">
          <Link to="/about" className="craft-story__link">
            Meet Corey <ArrowUpRight size={18} strokeWidth={1.5} aria-hidden="true" />
          </Link>
          <a href="#contact" className="craft-story__link craft-story__link--quiet">
            Talk about your project <ArrowUpRight size={18} strokeWidth={1.5} aria-hidden="true" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CraftStory;
